import { render, staticRenderFns } from "./divisa.vue?vue&type=template&id=76fd7bfc&"
import script from "./divisa.vue?vue&type=script&lang=js&"
export * from "./divisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./divisa.vue?vue&type=custom&index=0&blockType=tyle"
if (typeof block0 === 'function') block0(component)

export default component.exports